var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"bg-danger text-white text-center py-3",staticStyle:{"font-size":"1.3em"}},[_vm._v(" Restauracja jest nieczynna. Zapraszamy ponownie od 14 kwietnia. ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }